import {useFormik} from 'formik'
import React, {useState} from 'react'
import {useIntl} from 'react-intl'
import {CSSTransition} from 'react-transition-group'
import SettingsService from '../../../../core/_requests'
import {Button, ButtonBack} from '../../../../../../../_gori/partials/widgets'
import {toast} from 'react-toastify'
import useCancelToken from '../../../../../../../_gori/hooks/UseCancelToken'
import * as Yup from 'yup'
import {OrderType} from '../../../../../orders/core/_const'
import {StoresListing} from '../StoresListing'
import {isEmpty} from 'lodash'

import {PromotionBanner, BannerContent} from '../../../../../common/components/PromotionBanner'
import {usePromoEligibility} from '../../../../../../../_gori/hooks/UsePromoEligibility'
import {ConnectionLink} from '../ConnectionLink'
import {KTSVG} from '../../../../../../../_gori/helpers'
import {useNavigate} from 'react-router-dom'

const ConnectEbay: React.FC = () => {
  const intl = useIntl()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const {getMarketPromoStatus} = usePromoEligibility()
  const ebayPromoStatus = getMarketPromoStatus('ebay')
  const isPromoEligible = ebayPromoStatus.isEligible
  const isPromoApplied = ebayPromoStatus.isApplied
  const {newCancelToken} = useCancelToken()
  const navigate = useNavigate()
  const validationSchema = Yup.object().shape({})

  const initialValues = {
    store_type: OrderType.EBAY,
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async () => {
      setIsLoading(true)
      const config = {cancelToken: newCancelToken()}
      await SettingsService.getEbayConsentLink(config)
        .then((res) => {
          setIsLoading(false)
          window.location.replace(res)
        })
        .catch((error) => {
          let message = error?.response?.data?.error?.message ?? ''
          toast.error(isEmpty(message) ? intl.formatMessage({id: 'CONNECTION_FAILED'}) : message)
        })
        .finally(() => {})
    },
  })

  const ebayBannerContent: Partial<BannerContent> = {
    helpLinkTo: '/help-center/store-connection/ebay',
  }

  return (
    <>
      <CSSTransition appear in timeout={300} classNames='fade' unmountOnExit>
        <div className='store-connect-page'>
          <div className='store-connect-page__header'>
            <div className='store-connect-page__header-main'>
              <div className='d-flex align-items-center store-connect-page__back'>
                <ButtonBack className='store-connect-page__back-button me-0' />
                <button
                  type='button'
                  className='store-connect-page__back-arrow'
                  aria-label='Go back'
                  onClick={() => navigate(-1)}
                >
                  <KTSVG path='/media/gori/left_arrow.svg' />
                </button>
              </div>
              <div className='d-flex flex-column'>
                <div className='d-flex gap-4 align-items-center flex-wrap'>
                  <span className='store-connect-page__title fw-bolder text-dark fs-3'>
                    {intl.formatMessage({id: 'CONNECT_TO'})} eBay
                  </span>
                </div>
                <ConnectionLink url={ebayBannerContent.helpLinkTo || ''} />
              </div>
            </div>
            {isPromoApplied && (
              <PromotionBanner
                isEligible={isPromoEligible}
                isApplied={isPromoApplied}
                content={ebayBannerContent}
              />
            )}
          </div>
          <div className='store-connect-page__body'>
            <div className='store-connect-page__form-card store-connect-page__form-card--stacked'>
              <div className='store-connect-page__form-connect-bar'>
                <p className='store-connect-page__form-connect-notice'>
                  {intl.formatMessage({id: 'STORE_CONNECTION_MARKETPLACE_REDIRECT_NOTICE'})}
                </p>
                <Button
                  className='btn btn-advanced-primary store-connect-page__form-stack-connect'
                  loading={isLoading}
                  loadingText={intl.formatMessage({id: 'CONNECT'})}
                  label={intl.formatMessage({id: 'CONNECT'})}
                  event={() => {
                    formik.submitForm()
                  }}
                />
              </div>
            </div>
            <div className='store-connect-page__stores'>
              <StoresListing storeType={OrderType.EBAY} />
            </div>
          </div>
        </div>
      </CSSTransition>
    </>
  )
}

export {ConnectEbay}
